module.exports = __webpack_public_path__ + "assets/img/sea.43452548.png";